/** Transform object to non functional and non array. */
export type NonFunctionalAndArray<T> = T extends CallableFunction | readonly unknown[] ? never : T;
